import { z } from '@faceup/validation'
import { CustomDocumentType } from '../enums'
import { Language } from '../localization'

export const customDocumentLanguageSchema = z.enum(Language).nullable()

export const customDocumentTypeSchema = z.enum(CustomDocumentType).nullable()
